import { render, staticRenderFns } from "./ModalRewards.vue?vue&type=template&id=5b7049e1"
import script from "./ModalRewards.vue?vue&type=script&lang=js"
export * from "./ModalRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports